/* Evolved Elements Buyer's Report: story visuals that illustrate each section's text.
   Each visual mounts into an empty <div class="ee-vslot" data-v="..."> placed in the page markup,
   plays when it scrolls into view, and shows its finished state for reduced-motion visitors. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function h(html) { var d = document.createElement('div'); d.innerHTML = html; return d.firstChild; }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, reduce ? 0 : ms); }); }
  function countUp(el, to, dec, ms, pre, post) {
    pre = pre || ''; post = post || '';
    var fmt = function (v) { return pre + v.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + post; };
    if (reduce) { el.textContent = fmt(to); return; }
    var t0 = performance.now();
    (function f(t) { var p = Math.min(1, (t - t0) / ms), e = 1 - Math.pow(1 - p, 3); el.textContent = fmt(to * e); if (p < 1) requestAnimationFrame(f); })(t0);
  }
  function replayBtn(label) { return '<button type="button" class="eev-replay" data-replay>' + (label || '↻ Replay') + '</button>'; }

  /* ---------- Rule 1: the 1% New Zealand label loophole ---------- */
  function loophole(host) {
    var dots = function (nz) { var s = ''; for (var i = 0; i < 100; i++) s += '<i class="' + (i < nz ? 'nz' : 'scrap') + '" style="--d:' + i + '"></i>'; return s; };
    host.innerHTML =
      '<div class="eev-head"><span class="eev-kicker">What’s actually inside</span><b>Both bottles can legally say “New Zealand.”</b></div>' +
      '<div class="eev-loop-row">' +
        '<figure class="eev-bottle"><div class="eev-bottle-body"><div class="eev-dots">' + dots(1) + '</div><div class="eev-label">NEW ZEALAND</div></div>' +
          '<figcaption><b>A typical “NZ” label</b><span class="eev-stat"><em data-n="99">0</em>% imported feedlot scrap</span><span class="eev-stat nz"><em data-n="1">0</em>% New Zealand</span></figcaption></figure>' +
        '<figure class="eev-bottle ours"><div class="eev-bottle-body"><div class="eev-dots">' + dots(100) + '</div><div class="eev-label">NEW ZEALAND</div></div>' +
          '<figcaption><b>Evolved Elements</b><span class="eev-stat nz"><em data-n="100">0</em>% single-origin New Zealand</span><span class="eev-stat">Zero blending</span></figcaption></figure>' +
      '</div>' +
      '<div class="eev-legend"><span><i class="nz"></i>New Zealand Highland cattle</span><span><i class="scrap"></i>Imported feedlot scrap</span></div>' +
      '<p class="eev-note">Illustration of the loophole described above: a 1% pinch of New Zealand powder is enough to print “New Zealand” on the front.</p>' + replayBtn('↻ Look inside again');
    return function play() {
      host.classList.remove('is-open'); host.querySelectorAll('em[data-n]').forEach(function (e) { e.textContent = '0'; });
      return wait(700).then(function () {
        host.classList.add('is-open');
        host.querySelectorAll('em[data-n]').forEach(function (e) { countUp(e, +e.getAttribute('data-n'), 0, 1400); });
      });
    };
  }

  /* ---------- Rule 2: spray-dried chunks vs cryo-milled micro-granules ---------- */
  function dissolve(host) {
    var chunks = '', fines = '';
    for (var i = 0; i < 7; i++) chunks += '<i style="--x:' + (8 + i * 12) + '%;--s:' + (14 + (i * 7) % 12) + 'px;--r:' + (i * 37 % 90) + 'deg;--d:' + (i * 90) + 'ms"></i>';
    for (var j = 0; j < 42; j++) fines += '<i style="--x:' + (4 + (j * 23) % 90) + '%;--y:' + (8 + (j * 31) % 70) + '%;--d:' + (j * 25) + 'ms"></i>';
    host.innerHTML =
      '<div class="eev-head"><span class="eev-kicker">Time-lapse illustration</span><b>What happens in your stomach.</b></div>' +
      '<div class="eev-beakers">' +
        '<figure class="eev-beaker hot"><div class="eev-glass"><div class="eev-liquid"></div><div class="eev-chunks">' + chunks + '</div><span class="eev-heat">🔥 high-heat spray dried</span></div>' +
          '<figcaption><b>Scorched, coarse chunks</b><span>Sit in the stomach like gravel</span></figcaption></figure>' +
        '<figure class="eev-beaker cold"><div class="eev-glass"><div class="eev-liquid"></div><div class="eev-fines">' + fines + '</div><span class="eev-heat">❄ OrganEase cryo-milled</span></div>' +
          '<figcaption><b>Smooth micro-granules</b><span>Dissolve cleanly in <em class="eev-clock">0:00</em> min</span></figcaption></figure>' +
      '</div>' +
      '<div class="eev-steps"><span>Flash-heated for food safety</span><span>→</span><span>Frozen immediately</span><span>→</span><span>Cryo-milled</span></div>' + replayBtn();
    return function play() {
      host.classList.remove('is-run'); var clock = host.querySelector('.eev-clock'); clock.textContent = '0:00';
      return wait(400).then(function () {
        host.classList.add('is-run');
        if (reduce) { clock.textContent = '4:00'; return; }
        var t0 = performance.now(), ms = 3200;
        (function f(t) { var p = Math.min(1, (t - t0) / ms), sec = Math.round(p * 240); clock.textContent = Math.floor(sec / 60) + ':' + String(sec % 60).padStart(2, '0'); if (p < 1) requestAnimationFrame(f); })(t0);
      });
    };
  }

  /* ---------- Rule 3: what fills the capsule ---------- */
  function capsule(host) {
    host.innerHTML =
      '<div class="eev-head"><span class="eev-kicker">Inside one capsule</span><b>A capsule holds 500 to 600 mg. The serving is 200 mg. What fills the rest?</b></div>' +
      '<div class="eev-tog" role="group" aria-label="Compare capsules"><button type="button" data-cap="filler" aria-pressed="true">Typical filler capsule</button><button type="button" data-cap="ours" aria-pressed="false">Evolved Elements</button></div>' +
      '<div class="eev-cap"><div class="eev-cap-shell"><span class="seg t" ><b>~200 mg</b>thyroid tissue</span><span class="seg f"><b>300–400 mg</b><em class="lbl-f">flow agents + dense scrap</em><em class="lbl-o">organic chicory root inulin</em></span></div></div>' +
      '<div class="eev-cap-ruler"><span>0 mg</span><span>200</span><span>400</span><span>600 mg</span></div>' +
      '<ul class="eev-cap-list"></ul>' + replayBtn();
    var LIST = {
      filler: ['<b>Magnesium stearate</b> · waxy industrial lubricant that coats the powder', '<b>Silicon dioxide</b> · anti-caking “sand dust”', '<b>Dense scrap</b> · cheap bulk to fill the empty space'],
      ours: ['<b>01 · Shell</b> · 100% gelatin capsule', '<b>02 · Core</b> · 200 mg pure thyroid tissue', '<b>03 · Carrier</b> · organic chicory root inulin, a prebiotic plant fiber. Zero magnesium stearate, zero silicon dioxide.']
    };
    var mode = 'filler';
    function set(m) {
      mode = m; host.setAttribute('data-mode', m);
      host.querySelectorAll('[data-cap]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-cap') === m)); });
      host.querySelector('.eev-cap-list').innerHTML = LIST[m].map(function (x, i) { return '<li style="--d:' + i + '">' + x + '</li>'; }).join('');
      host.classList.remove('is-fill'); void host.offsetWidth; host.classList.add('is-fill');
    }
    host.addEventListener('click', function (e) { var b = e.target.closest('[data-cap]'); if (b) { host.__touched = 1; set(b.getAttribute('data-cap')); } });
    set('filler');
    return function play() {
      set('filler');
      return wait(2600).then(function () { if (!host.__touched) set('ours'); });
    };
  }

  /* ---------- Label math ---------- */
  function math(host) {
    var row = function (label, ours, oursTxt, them, themTxt, note) {
      return '<div class="eev-mrow"><div class="eev-mlabel">' + label + (note ? '<small>' + note + '</small>' : '') + '</div>' +
        '<div class="eev-mbar ours"><i style="--w:' + ours + '%"></i><span>Evolved Elements</span><b>' + oursTxt + '</b></div>' +
        '<div class="eev-mbar them"><i style="--w:' + them + '%"></i><span>Leading brand</span><b>' + themTxt + '</b></div></div>';
    };
    host.innerHTML =
      '<div class="eev-head"><span class="eev-kicker">The label math, visualized</span><b>More thyroid. Less per day.</b></div>' +
      '<div class="eev-mbig"><strong class="eev-x">0.0×</strong><span>more active thyroid tissue per bottle</span></div>' +
      row('Thyroid tissue per bottle', 100, '12,000 mg', 45, '5,400 mg') +
      row('Thyroid tissue per capsule', 100, '200 mg', 15, '30 mg') +
      row('Cost per day', 72, '$1.17–$1.33', 100, '$1.73+', 'shorter is better') +
      '<p class="eev-note">From the label figures in the table above. Competitor figures reflect publicly listed label information at the time of the audit.</p>' + replayBtn();
    return function play() {
      host.classList.remove('is-run'); host.querySelector('.eev-x').textContent = '0.0×';
      return wait(300).then(function () { host.classList.add('is-run'); countUp(host.querySelector('.eev-x'), 2.2, 1, 1500, '', '×'); });
    };
  }

  /* ---------- Lab results ---------- */
  function labs(host) {
    var T = [
      ['01', 'Heavy metals', 'Cadmium and mercury not detected. Lead under 1% of USP limits.', 'ICP-MS · Harken Research'],
      ['02', 'Tissue authenticity', '100% pure grass-fed thyroid tissue. Zero adulterants.', 'TLC USP <201> · Colmaric Analyticals'],
      ['03', 'Bacteria screen', 'Salmonella, E. coli, and staph all negative.', 'AOAC · Daane Labs'],
      ['04', 'Allergen screen', 'Gluten, peanut, and soy under detection limits.', 'ELISA · Romer Labs']
    ];
    host.innerHTML =
      '<div class="eev-head"><span class="eev-kicker">Finished lot 2606001</span><b>Four independent US labs. Four passes.</b></div>' +
      '<div class="eev-scan"><div class="eev-beam" aria-hidden="true"></div>' +
      T.map(function (t, i) {
        return '<div class="eev-test" style="--i:' + i + '"><span class="eev-tn">' + t[0] + '</span><div><b>' + t[1] + '</b><span>' + t[2].replace(/</g, '&lt;') + '</span><small>' + t[3].replace(/</g, '&lt;') + '</small></div><span class="eev-stamp">✓ Passed</span></div>';
      }).join('') + '</div>' + replayBtn('↻ Run the scan again');
    return function play() {
      host.classList.remove('is-run');
      return wait(250).then(function () { host.classList.add('is-run'); });
    };
  }

  /* ---------- Try-it guarantee ---------- */
  function guarantee(host) {
    host.innerHTML =
      '<div class="eev-head"><span class="eev-kicker">How the try-it guarantee works</span><b>365 days to decide.</b></div>' +
      '<div class="eev-gwrap">' +
        '<div class="eev-ring"><svg viewBox="0 0 120 120" aria-hidden="true"><circle cx="60" cy="60" r="52" class="bg"/><circle cx="60" cy="60" r="52" class="fg"/></svg><div><strong class="eev-days">0</strong><span>days</span></div></div>' +
        '<ol class="eev-gsteps">' +
          '<li style="--i:0"><span class="eev-gi">1</span><div><b>Open your try-it bottle</b><span>Your first bottle. Take one capsule every morning.</span></div></li>' +
          '<li style="--i:1"><span class="eev-gi">2</span><div><b>Not right for you?</b><span>Send back that opened bottle plus every unopened bottle from your order.</span></div></li>' +
          '<li style="--i:2"><span class="eev-gi">3</span><div><b>100% refund</b><span>Of your purchase price. No restocking fees.</span></div></li>' +
        '</ol>' +
      '</div>' + replayBtn();
    return function play() {
      host.classList.remove('is-run'); host.querySelector('.eev-days').textContent = '0';
      return wait(250).then(function () { host.classList.add('is-run'); countUp(host.querySelector('.eev-days'), 365, 0, 1800); });
    };
  }

  var KINDS = { loophole: loophole, dissolve: dissolve, capsule: capsule, math: math, labs: labs, guarantee: guarantee };

  function mountAll() {
    document.querySelectorAll('.ee-vslot[data-v]').forEach(function (slot) {
      if (slot.querySelector('.eev')) return;
      var kind = slot.getAttribute('data-v'), make = KINDS[kind]; if (!make) return;
      var host = slot.__eev || document.createElement('div');
      slot.appendChild(host);
      if (slot.__eev) return; // re-attached after a re-render
      slot.__eev = host;
      host.className = 'eev eev-' + kind;
      var play = make(host);
      host.addEventListener('click', function (e) { if (e.target.closest('[data-replay]')) play(); });
      if (reduce || !('IntersectionObserver' in window)) { host.classList.add('is-static'); play(); return; }
      var fired = false, go = function () { if (fired) return; fired = true; io.disconnect(); play(); };
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) go(); }, { threshold: 0.35 });
      io.observe(host);
      host.__go = go;
    });
  }

  /* ---------- Gentle scroll reveal for section headings and figures ---------- */
  function reveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = reveal.io || (reveal.io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('ee-rv-in'); io.unobserve(x.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }));
    document.querySelectorAll('main h2, section h2, .eev').forEach(function (el) {
      if (el.__rv) return; el.__rv = 1;
      if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('ee-rv'); io.observe(el); }
    });
  }

  // Backup for the in-view observers: on scroll, show and play anything that is on screen.
  var sq = 0;
  window.addEventListener('scroll', function () {
    if (sq) return;
    sq = setTimeout(function () {
      sq = 0; var vh = window.innerHeight;
      document.querySelectorAll('.ee-rv:not(.ee-rv-in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < vh * 0.92 && r.bottom > 0) el.classList.add('ee-rv-in'); });
      document.querySelectorAll('.eev').forEach(function (el) { if (!el.__go) return; var r = el.getBoundingClientRect(); if (r.top < vh * 0.75 && r.bottom > vh * 0.2) el.__go(); });
    }, 150);
  }, { passive: true });
  function boot() { mountAll(); reveal(); }
  function start() {
    boot();
    var q = 0;
    new MutationObserver(function () { if (!q) q = setTimeout(function () { q = 0; boot(); }, 250); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
